export default {"src":"/fly/_next/static/media/jetsmart_logo.c4def2da.svg","height":53,"width":226,"blurWidth":0,"blurHeight":0};